import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "table_wrap"
}
const _hoisted_2 = { class: "areaGrid" }
const _hoisted_3 = {
  key: 0,
  class: "checkbox_wrap"
}
const _hoisted_4 = { for: "allCheckbox" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = ["innerHTML", "onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["colspan"]
const _hoisted_9 = {
  key: 0,
  class: "areaPaing"
}
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return ($setup.props.isLoading)
    ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (col, idx) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: idx,
                  class: _normalizeClass([col.class])
                }, [
                  (col.key === 'checkbox')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("label", _hoisted_4, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            id: "allCheckbox",
                            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.selectAll && $setup.selectAll(...args))),
                            checked: $props.list.length === $props.list.filter((r) => r.checked).length
                          }, null, 40, _hoisted_5),
                          _cache[5] || (_cache[5] = _createElementVNode("em", null, null, -1))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(col.label), 1)
                      ], 64))
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            ($props.list.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.list, (row, idx) => {
                  return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.columns, (col, colIdx) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: colIdx,
                        innerHTML: $setup.fnRender(row, col, idx),
                        onClick: ($event: any) => (col.clickable === true ? $setup.onRowClick(row, col) : ''),
                        class: _normalizeClass([col.clickable === true ? 'areaClick' : '', col.class]),
                        style: _normalizeStyle({ cursor: col.clickable ? 'pointer' : '', textDecoration: col.clickable ? 'underline' : '' })
                      }, null, 14, _hoisted_6))
                    }), 128))
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                  _createElementVNode("td", {
                    colspan: $props.columns.length,
                    class: "text-center"
                  }, "데이터가 없습니다.", 8, _hoisted_8)
                ]))
          ])
        ]),
        ($setup.props.currentPage && $setup.props.cntPage && $setup.props.list.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
              _createElementVNode("li", {
                class: "first_page page",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($props.currentPage > 1 ? $setup.fnPaging(1) : ''))
              }),
              _createElementVNode("li", {
                class: "prev_page page",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($props.currentPage > 1 ? $setup.fnPaging($setup.visiblePages[0] - 1) : ''))
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visiblePages, (index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onClick: ($event: any) => ($setup.fnPaging(index)),
                  class: _normalizeClass([index === $props.currentPage ? 'active' : ''])
                }, _toDisplayString(index), 11, _hoisted_10))
              }), 128)),
              _createElementVNode("li", {
                class: "next_page page",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($props.currentPage < $setup.paging ? $setup.fnPaging($setup.visiblePages[$setup.visiblePages.length - 1] + 1) : ''))
              }),
              _createElementVNode("li", {
                class: "last_page page",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.fnPaging($setup.paging)))
              })
            ]))
          : _createCommentVNode("", true)
      ]))
}